<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'base-nested-view',
};
</script>
